<script setup>

  import axios from 'axios';
  import AxiosHelper from '../../utils/axios_helper'; //CSRF

  import { ref, onMounted  } from 'vue';

  import Filtro from "./Filtro.vue";
  
  // Constants
  const filtros = ref(JSON.parse(document.getElementById("filtros").value));
  const test_code = document.getElementById("test_code").value;

  const validate = ref(true);

  // New: Nueva prueba, metemos filtros por primera vez. 
  // Edit: Estamos editando los filtros
  const new_or_edit = document.getElementById("new_or_edit").value;
  let prueba_code = null;

  // Hooks
  // Si existe prueba, ponemos valores a los filtros una vez se ha montado todo
  onMounted(() => {

    if(document.getElementById("prueba")  != null){
      let prueba = JSON.parse(document.getElementById("prueba").value);
      prueba_code = prueba.code;

      for (let i=0; i < filtros.value.length; i++) {
        let filtro = filtros.value[i];
        
        // Los filtros default tiene campo propio en base de datos
        if(filtro.default == true) {
          filtro.value = prueba[filtro.field_db];
          if(filtro.tipo == "email"){filtro.value_confirmacion = prueba[filtro.tipo];}
        
        // El resto de los filtros los tenemos que buscar por id dentro del campo filtros
        }else{
          filtro.value = prueba.filtros.filter((f) => f.filtro_id == filtro.id)[0].value;
        }
        

      }

    }
  
  })


  async function enviar_datos() {
    
    validate_presence();    
    if( !validate.value ) return;

    //CSRF
    AxiosHelper();

    // Crea o actualiza
    (new_or_edit == "new") ? await crear_prueba() : await actualizar_filtros();
      
  } 


  // Creación prueba
  async function crear_prueba() {

    try {
      const response = await axios.post("/pruebas.json", { test_code: test_code, prueba: { filtros: filtros.value} });
      //Ponemos el id, que es el dato nuevo.
      if(response.statusText == "Created") {
        window.location.replace(response.data.redirect);
      }
      
    } catch (error){ 
      console.log(error);
    }
  }

   async function actualizar_filtros() {

    try {
      const response = await axios.put("/prueba/"+prueba_code+"/filtros.json", { prueba: { filtros: filtros.value} });
      //Ponemos el id, que es el dato nuevo.
    
      if(response.statusText == "OK") {
        window.location.replace(response.data.redirect);
      }

    } catch (error){ 
      console.log(error);
    }
  }


  // Validaciones

  function validate_presence() {
    validate.value = true; //Reiniciamos
    for (let i = 0; i < filtros.value.length; i++) {
      let filtro = filtros.value[i];
      
      // Validate: campos en blanco
      if (filtro.value == null || filtro.value == "") {
        validate.value = false;
        filtro.error = true;
        filtro.error_msg = "El campo '"+filtro.nombre+"' no puede estar en blanco."
      }else {
        filtro.error = false;
        filtro.msg = "";
      }

      //Validate: confirmación email
      if(filtro.tipo =="email" && filtro.value != filtro.value_confirmacion) {
        validate.value = false;
        filtro.error = true;
        filtro.error_msg = "El email no coincide con la confirmación"
      }
    }

  }
  
</script>

<template>

  <div class="flex flex-col ">
    <filtro v-for="filtro in filtros.sort((a, b) => a.id - b.id)" :key="filtro.id" :filtro="filtro"></filtro>  
    <div class="my-5">
      <span class="block button w-full" @click="enviar_datos">{{ new_or_edit == "new" ? "Iniciar test" : "Actualizar datos" }}</span>
    </div>
  </div>
  
  <div class="bg-red-100 p-3" v-if="!validate" >
    <h4>Revisa los sigientes errores</h4>
    <p v-for="filtro in filtros.filter((f) => f.error)" :key="filtro.id">{{ filtro.error_msg }}</p>
  </div>
  
</template>

<style lang="scss">

</style>